import React from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide';

interface WrapperProps {
  color: string;
}

const Wrapper = styled.button<WrapperProps>`
  ${({ color }: WrapperProps) => (color ? `background: ${colors(color)}` : '')};
  height: 32px;
  width: 32px;
  cursor: pointer;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  border: none;
  border-left: 1px solid ${colors('neutral', 3)}};
  border-top: 1px solid ${colors('neutral', 3)}};
  border-bottom: 1px solid ${colors('neutral', 3)}};

  transition: background 0.4s ease;
`;

interface Props {
  color: string;
  children: any;
  onClick: () => boolean | void;
}

const Button = React.forwardRef(({ color, onClick, children, ...otherProps }: Props, ref: any) => (
  <Wrapper ref={ref} color={color} onClick={onClick} {...otherProps}>
    {children}
  </Wrapper>
));

export default Button;
